export default {
  INPUT_CLAIMS: 'inputClaims',
  INPUT_PARAMETERS: 'inputParameters',
  DISPLAY_CLAIMS: 'displayClaims',
  PERSISTED_CLAIMS: 'persistedClaims',
  OUTPUT_CLAIMS: 'outputClaims',
  INPUT_CLAIMS_TRANSFORMATIONS: 'inputClaimsTransformations',
  OUTPUT_CLAIMS_TRANSFORMATIONS: 'outputClaimsTransformations',
  VALIDATION_TECHNICAL_PROFILES: 'validationTechnicalProfiles',
  VALIDATION_METADATA: 'metadata',
  CLAIMS: 'claims',
  CLAIM: 'claim',
  PROTOCOL_NAME: {
    selfAssertedProfiles: 'selfAssertedProfiles',
    otherProfile: 'otherProfiles',
  },
  // actions: 'Actions',
  // sessionMgmt: 'SessionManagement',

  PROTOCOLS: {
    'REST-API': [
      'Proprietary',
      'Web.TPEngine.Providers.RestfulProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
    ],
    AAD_PROTOCOL: [
      'Proprietary',
      'Web.TPEngine.Providers.AzureActiveDirectoryProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
    ],
  },

  CATEGORY: {
    ORCHSTEPNAME: 'Orchestration Step Name',
    PRECONDITION: 'Precondition',
    INPUTCLAIMS: 'Input Claims',
    OUTPUTCLAIMS: 'Output Claims',
    DISPLAYCLAIMS: 'Display Claims',
    PERSISTEDCLAIMS: 'Persisted Claims',
    PARTNERCLAIMTYPE: 'Partner Claim Type',
    DEFAULTVALUE: 'Default Value',
    INPUTCLAIMSTRANSNAME: 'Input Claims Transformation Name',
    OUTPUTCLAIMSTRANSNAME: 'Output Claims Transformation Name',
    VALIDATIONTPNAME: 'Validation TP Name',
  },
  TECHNICAL_PROFILES: {
    selfAssertedProfiles: {
      name: 'SELF ASSERTED PROFILE',
      displayName: 'Self Asserted Profile',
      protocol: [
        'Proprietary',
        'Web.TPEngine.Providers.SelfAssertedAttributeProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
      ],
      claimProvider: 'Self Asserted',
      metadata: [['ContentDefinitionReferenceId', 'api.selfAsserted']],
    },
    'REST-API': {
      name: 'REST-API',
      displayName: 'ProgProfReadAfterApi',
      protocol: [
        'Proprietary',
        'Web.TPEngine.Providers.RestfulProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
      ],
      claimProvider: 'REST API',
      metadata: [
        ['AllowInsecureAuthInProduction', 'false'],
        ['AuthenticationType', 'ClientCertificate'],
        ['IncludeClaimResolvingInClaimsHandling', 'false'],
        ['SendClaimsIn', 'Body'],
        ['ServiceUrl', ''],
        ['UseClaimAsBearerToken', ''],
      ],
    },
    MFA: {
      name: 'MFA',
      displayName: 'PhoneFactor',
      protocol: [
        'Proprietary',
        'Web.TPEngine.Providers.PhoneFactorProtocolProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
      ],
      claimProvider: 'PhoneFactor',
      metadata: [
        ['ContentDefinitionReferenceId', 'api.phonefactor'],
        ['ManualPhoneNumberEntryAllowed', 'true'],
      ],
      data: {
        check: {
          claimTransformations: ['CreateUserIdForMFA'],
          claims: [
            'userIdForMFA',
            'strongAuthenticationPhoneNumber',
            'Verified.strongAuthenticationPhoneNumber',
            'newPhoneNumberEntered',
          ],
        },
        CreateUserIdForMFA: {
          id: 'CreateUserIdForMFA',
          transformationmethod: 'FormatStringClaim',
          inputClaims: [
            {
              claimReferenceId: 'objectId',
              transformationClaimType: 'inputClaim',
            },
          ],
          inputParameters: [
            {
              id: 'stringFormat',
              dataType: 'string',
              value: '{0}@{RelyingPartyTenantId}',
            },
          ],
          outputClaims: [
            {
              claimReferenceId: 'userIdForMFA',
              transformationClaimType: 'outputClaim',
            },
          ],
        },
        userIdForMFA: {
          id: 'userIdForMFA',
          displayName: 'UserId for MFA',
          userInputType: '',
          dataType: 'string',
        },
        strongAuthenticationPhoneNumber: {
          id: 'strongAuthenticationPhoneNumber',
          displayName: 'Phone Number',
          userInputType: '',
          dataType: 'string',
        },
        'Verified.strongAuthenticationPhoneNumber': {
          id: 'Verified.strongAuthenticationPhoneNumber',
          displayName: 'Verified Phone Number',
          userInputType: '',
          dataType: 'string',
        },
        newPhoneNumberEntered: {
          id: 'newPhoneNumberEntered',
          displayName: 'New Phone Number Entered',
          userInputType: '',
          dataType: 'boolean',
        },
        add: {
          inputClaimsTransformations: ['CreateUserIdForMFA'],
          inputClaims: [
            {
              claimTypeReferenceId: 'userIdForMFA',
              partnerClaimType: 'UserId',
              defaultValue: '',
              required: false,
              alwaysUseDefaultValue: false,
            },
            {
              claimTypeReferenceId: 'strongAuthenticationPhoneNumber',
              partnerClaimType: '',
              defaultValue: '',
              required: false,
              alwaysUseDefaultValue: false,
            },
          ],
          outputClaims: [
            {
              claimTypeReferenceId: 'Verified.strongAuthenticationPhoneNumber',
              partnerClaimType: 'Verified.OfficePhone',
              defaultValue: '',
              required: false,
              alwaysUseDefaultValue: false,
            },
            {
              claimTypeReferenceId: 'newPhoneNumberEntered',
              partnerClaimType: 'newPhoneNumberEntered',
              defaultValue: '',
              required: false,
              alwaysUseDefaultValue: false,
            },
          ],
        },
      },
    },
    // SESSION_MANAGEMENT: {
    //   name: 'SESSION MANAGEMENT',
    //   displayName: 'Session Mananagement Provider',
    //   protocol: [
    //     'Proprietary',
    //     'Web.TPEngine.SSO.DefaultSSOSessionProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
    //   ],
    //   claimProvider: '',
    //   metadata: [],
    // },
    OpenIdConnect: {
      name: 'OPENID CONNECT',
      displayName: 'Local Account SignIn',
      protocol: ['OpenIdConnect', ''],
      claimProvider: '',
      metadata: [],
    },
    'AAD-Read': {
      name: 'AAD-Read',
      displayName: 'Azure Active Directory',
      protocol: ['', ''],
      claimProvider: '',
      metadata: [
        ['Operation', 'Read'],
        ['RaiseErrorIfClaimsPrincipalDoesNotExist', 'false'],
        ['RaiseErrorIfClaimsPrincipalAlreadyExists', 'false'],
        ['IncludeInSSO', 'false'],
      ],
      includeTechnicalProfile: 'AAD-Common',
      data: {
        delete: ['persistedClaims'],
      },
    },
    'AAD-Write': {
      name: 'AAD-Write',
      displayName: 'Azure Active Directory',
      protocol: ['', ''],
      claimProvider: '',
      metadata: [
        ['Operation', 'Write'],
        ['RaiseErrorIfClaimsPrincipalDoesNotExist', 'false'],
        ['RaiseErrorIfClaimsPrincipalAlreadyExists', 'false'],
        ['IncludeInSSO', 'false'],
      ],
      includeTechnicalProfile: 'AAD-Common',
      data: {
        add: {
          persistedClaims: [],
        },
      },
    },
    // SSO: {
    //   name: 'SSO',
    //   displayName: 'Session Mananagement Provider',
    //   protocol: [
    //     'Proprietary',
    //     'Web.TPEngine.SSO.DefaultSSOSessionProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
    //   ],
    //   claimProvider: '',
    //   metadata: [],
    // },
    APP_INSIGHTS: {
      name: 'AppInsights',
      displayName: 'Application Insights',
      protocol: ['', ''],
      claimProvider: 'Application Insights',
      metadata: [
        ['InstrumentationKey', '5b680b99-840d-4695-a297-b57ec22e52c5'],
        ['DeveloperMode', 'false'],
        ['DisableTelemetry ', 'false'],
      ],
      includeTechnicalProfile: 'AppInsights-Common',
    },
  },

  AAD_ATTRIBUTES: [
    'accountEnabled',
    'ageGroup',
    'alternativeSecurityId',
    'alternativeSecurityIds',
    'city',
    'consentProvidedForMinor',
    'country',
    'createdDateTime',
    'creationType',
    'department',
    'displayName',
    'facsimileTelephoneNumber',
    'givenName',
    'jobTitle',
    'immutableId',
    'legalAgeGroupClassification',
    'legalCountry',
    'mailNickName',
    'mobile',
    'netId',
    'objectId',
    'otherMails',
    'password',
    'passwordPolicies',
    'physicalDeliveryOfficeName',
    'postalCode',
    'preferredLanguage',
    'refreshTokensValidFromDateTime',
    'signInNames',
    'signInNames.userName',
    'signInNames.phoneNumber',
    'signInNames.emailAddress',
    'state',
    'streetAddress',
    'strongAuthenticationAlternativePhoneNumber',
    'strongAuthenticationEmailAddress',
    'strongAuthenticationPhoneNumber',
    'surname',
    'telephoneNumber',
    'userPrincipalName',
    'usageLocation',
    'userType',
    'userState',
    'userStateChangedOn',
  ],
  getMetaData: (type: string) => {
    switch (type) {
      case 'selfAssertedProfiles':
        return {
          ContentDefinitionReferenceId: {
            value: '',
            label: 'Content Definition ReferenceId',
            validate: ['NOT_EMPTY', 'NO_SPACES'],
          },
        };
      case 'REST-API':
        return {
          AllowInsecureAuthInProduction: {
            value: 'false',
            label: 'AllowInsecureAuthInProduction',
            options: [
              { label: 'true', value: 'true' },
              { label: 'false', value: 'false' },
            ],
          },
          AuthenticationType: {
            value: 'ClientCertificate',
            label: 'Authentication Type',
            options: [
              { label: 'None', value: 'None' },
              { label: 'Basic', value: 'Basic' },
              { label: 'Bearer', value: 'Bearer' },
              { label: 'ClientCertificate', value: 'ClientCertificate' },
              { label: 'ApiKeyHeader', value: 'ApiKeyHeader' },
            ],
          },
          IncludeClaimResolvingInClaimsHandling: {
            value: 'false',
            label: 'IncludeClaimResolvingInClaimsHandling',
            options: [
              { label: 'true', value: 'true' },
              { label: 'false', value: 'false' },
            ],
          },
          SendClaimsIn: {
            value: 'Body',
            label: 'SendClaimsIn',
            options: [
              { label: 'Body', value: 'Body' },
              { label: 'Form', value: 'Form' },
              { label: 'Header', value: 'Header' },
              { label: 'Url', value: 'Url' },
              { label: 'QueryString', value: 'QueryString' },
            ],
          },
          ServiceUrl: {
            value: '',
            label: 'Service Url',
          },
          UseClaimAsBearerToken: {
            value: '',
            label: 'UseClaimAsBearerToken',
          },
        };
      case 'AAD-Read':
        return {
          Operation: {
            value: 'Read',
            label: 'Operation',
            disabled: 'true',
          },
          RaiseErrorIfClaimsPrincipalDoesNotExist: {
            value: 'false',
            label: 'RaiseErrorIfClaimsPrincipalDoesNotExist',
            options: [
              { label: 'true', value: 'true' },
              { label: 'false', value: 'false' },
            ],
          },

          RaiseErrorIfClaimsPrincipalAlreadyExists: {
            value: 'false',
            label: 'RaiseErrorIfClaimsPrincipalAlreadyExists',
            options: [
              { label: 'true', value: 'true' },
              { label: 'false', value: 'false' },
            ],
          },
          //https://docs.microsoft.com/en-us/azure/active-directory-b2c/active-directory-technical-profile#metadata
          IncludeInSSO: {
            value: 'false',
            label: 'IncludeInSSO',
            options: [
              { label: 'true', value: 'true' },
              { label: 'false', value: 'false' },
            ],
          },
        };
      case 'AAD-Write':
        return {
          Operation: {
            value: 'Write',
            label: 'Operation',
            disabled: 'true',
          },
          RaiseErrorIfClaimsPrincipalDoesNotExist: {
            value: 'false',
            label: 'RaiseErrorIfClaimsPrincipalDoesNotExist',
            options: [
              { label: 'true', value: 'true' },
              { label: 'false', value: 'false' },
            ],
          },

          RaiseErrorIfClaimsPrincipalAlreadyExists: {
            value: 'false',
            label: 'RaiseErrorIfClaimsPrincipalAlreadyExists',
            options: [
              { label: 'true', value: 'true' },
              { label: 'false', value: 'false' },
            ],
          },
          //https://docs.microsoft.com/en-us/azure/active-directory-b2c/active-directory-technical-profile#metadata
          IncludeInSSO: {
            value: 'false',
            label: 'IncludeInSSO',
            options: [
              { label: 'true', value: 'true' },
              { label: 'false', value: 'false' },
            ],
          },
        };
      case 'OAuth2':
        return {
          ProviderName: { value: '', label: 'Provider Name', validate: [] },
          AccessTokenEndpoint: { value: '', label: 'Access Token Endpoint', validate: ['NOT_EMPTY', 'NO_SPACES'] },
          AccessTokenResponseFormat: {
            value: 'json',
            label: 'Access Token Response Format',
            options: [
              { label: 'default', value: 'default' },
              { label: 'json', value: 'json' },
              { label: 'jsonp', value: 'jsonp' },
            ],
          },
          ClaimsEndpoint: { value: '', label: 'Claims Endpoint', validate: ['NOT_EMPTY', 'NO_SPACES'] },
          UsePolicyInRedirectUri: {
            value: '',
            label: 'Use Policy In Redirect Uri',
          },
          authorization_endpoint: { value: '', label: 'Authorization endpoint', validate: ['NOT_EMPTY', 'NO_SPACES'] },
          client_id: { value: '', label: 'Client Id', validate: ['NOT_EMPTY', 'NO_SPACES'] },
          scope: {
            value: '',
            label: 'Scope',
          },
          HttpBinding: {
            value: '',
            label: 'Http Binding',
            options: [
              { label: 'GET', value: 'GET' },
              { label: 'POST', value: 'POST' },
            ],
          },
          BearerTokenTransmissionMethod: {
            value: '',
            label: 'Bearer Token Transmission Method',
            validate: [],
          },
          ResolveJsonPathsInJsonTokens: {
            value: 'false',
            label: 'Resolve Json Paths In Json Tokens',
            options: [
              { label: 'true', value: 'true' },
              { label: 'false', value: 'false' },
            ],
          },
        };
      case 'OpenIdConnect':
        return {
          METADATA: { value: '', label: 'METADATA', validate: ['NOT_EMPTY', 'NO_SPACES'] },
          client_id: { value: '', label: 'Client Id', validate: ['NOT_EMPTY', 'NO_SPACES'] },
          response_types: {
            value: 'id_token',
            label: 'Response Types',
            options: [
              { label: 'id_token', value: 'id_token' },
              { label: 'code', value: 'code' },
              { label: 'token', value: 'token' },
            ],
          },
          response_mode: {
            value: 'form_post',
            label: 'Response Mode',
            options: [
              { label: 'form_post', value: 'form_post' },
              { label: 'query', value: 'query' },
              { label: 'fragment', value: 'fragment' },
            ],
          },
          scope: { value: '', label: 'Scope' },
          HttpBinding: {
            value: '',
            label: 'Http Binding',
            options: [
              { label: 'GET', value: 'GET' },
              { label: 'POST', value: 'POST' },
            ],
          },
          UsePolicyInRedirectUri: {
            value: '',
            label: 'Use Policy In Redirect Uri',
          },
        };
      case 'APP-INSIGHTS':
        return {
          InstrumentationKey: {
            value: '',
            label: 'Instrumentation Key',
            validate: ['NOT_EMPTY', 'NO_SPACES'],
          },
          DeveloperMode: {
            value: 'false',
            label: 'Developer Mode',
            options: [
              { label: 'true', value: 'true' },
              { label: 'false', value: 'false' },
            ],
          },
          DisableTelemetry: {
            value: 'false',
            label: 'Disable Telemetry',
            options: [
              { label: 'true', value: 'true' },
              { label: 'false', value: 'false' },
            ],
          },
        };
      default:
        window.alert('Metadata configuration not available for ' + type);
        return {};
    }
  },

  getValidatorMsg: (validator: any, value: any, label: any) => {
    let validateMsg = '';
    validator.forEach((validat: string) => {
      switch (validat) {
        case 'NOT_EMPTY':
          if (value.trim() === '') validateMsg += label + ' cannot be empty. ';
          break;
        case 'NO_SPACES':
          if (value.trim().includes(' ')) validateMsg += label + ' cannot have empty space(s). ';
          break;
        case 'LENGTH>10':
          if (value.trim().length <= 10) validateMsg += label + ' should have atleast 10 characters. ';
          break;
      }
    });
    return validateMsg;
  },

  HELPTEXT: {
    Domain: {
      header: 'Domain',
      description:
        'The domain name for the technical profile. For example, if your technical profile specifies the Facebook identity provider, the domain name is Facebook.com.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    DisplayName: {
      header: 'DisplayName',
      description: 'The display name of the technical profile.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    Description: {
      header: 'Description',
      description: 'The description of the technical profile.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    Protocol: {
      header: 'Protocol',
      description: 'The protocol used for the communication with the other party.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    Metadata: {
      header: 'Metadata',
      description: 'A set of keys and values that controls the behavior of the technical profile.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    SessionContext: {
      header: 'Claim Resolvers',
      description:
        'Claim resolvers in Azure Active Directory B2C (Azure AD B2C) custom policies provide context information about an authorization request, such as the policy name, request correlation ID, user interface language, and more.',
      link: 'https://learn.microsoft.com/en-us/azure/active-directory-b2c/claim-resolver-overview',
    },
    InputTokenFormat: {
      header: 'InputTokenFormat',
      description:
        'The format of the input token. Possible values are JSON, JWT, SAML11, or SAML2. The JWT value represents a JSON Web Token per the IETF specification. The SAML11 value represents a SAML 1.1 security token per the OASIS specification. The SAML2 value represents a SAML 2.0 security token per the OASIS specification.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    OutputTokenFormat: {
      header: 'OutputTokenFormat',
      description: 'The format of the output token. Possible values are JSON, JWT, SAML11, or SAML2.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    CryptographicKeys: {
      header: 'CryptographicKeys',
      description: 'A list of cryptographic keys that are used in the technical profile.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    InputClaimsTransformations: {
      header: 'InputClaimsTransformations',
      description:
        'A list of previously defined references to claims transformations that should be executed before any claims are sent to the claims provider or the relying party.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    InputClaims: {
      header: 'InputClaims',
      description: 'The values in input claims are available to be pre-filled into ux elements in this page',
      // 'A list of previously defined references to claim types that are taken as input in the technical profile.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    PersistedClaims: {
      header: 'PersistedClaims',
      description:
        'A list of previously defined references to claim types that will be persisted by the technical profile.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    DisplayClaims: {
      header: 'DisplayClaims',
      description: 'These ux elements will be used to collect input from the users',
      // 'A list of previously defined references to claim types that are presented by the self-asserted technical profile. The DisplayClaims feature is currently in preview.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    OutputClaims: {
      header: 'OutputClaims',
      description:
        'These claims will be emitted as output when this page is successfully executed. Note that if a display claim is not listed here, then the value of the display claim will not be in the output of this page',
      // 'A list of previously defined references to claim types that are taken as output in the technical profile.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    OutputClaimsTransformations: {
      header: 'OutputClaimsTransformations',
      description:
        'A list of previously defined references to claims transformations that should be executed after the claims are received from the claims provider.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    ValidationTechnicalProfiles: {
      header: 'ValidationTechnicalProfiles',
      description: 'The following actions will be executed when the page is submitted',
      // 'A list of references to other technical profiles that the technical profile uses for validation purposes. The following actions will be executed when the page is submitted.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/validation-technical-profile',
    },
    SubjectNamingInfo: {
      header: 'SubjectNamingInfo',
      description:
        'Controls the production of the subject name in tokens where the subject name is specified separately from claims. Examples are OAuth or SAML.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    IncludeInSso: {
      header: 'IncludeInSso',
      description:
        'Whether usage of this technical profile should apply SSO behavior for the session or instead require explicit interaction. This element is valid only in SelfAsserted profiles used within a validation technical profile. Possible values are true (default) or false.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    IncludeClaimsFromTechnicalProfile: {
      header: 'IncludeClaimsFromTechnicalProfile',
      description:
        'An identifier of a technical profile from which you want all of the input and output claims to be added to this technical profile. The referenced technical profile must be defined in the same policy file.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    IncludeTechnicalProfile: {
      header: 'IncludeTechnicalProfile',
      description:
        'An identifier of a technical profile from which you want all data to be added to this technical profile.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    UseTechnicalProfileForSessionManagement: {
      header: 'UseTechnicalProfileForSessionManagement',
      description: 'A different technical profile to be used for session management.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    EnabledForUserJourneys: {
      header: 'EnabledForUserJourneys',
      description: 'Controls if the technical profile is executed in a user journey.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    RESTAPIValidationTP: {
      header: 'REST API Validation Technical Profile',
      description: 'Calls a rest api.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
    AADValidationTP: {
      header: 'AAD Validation Technical Profile',
      description: 'Can be used to read or write data from Azure Active Directory.',
      link: 'https://docs.microsoft.com/en-us/azure/active-directory-b2c/technicalprofiles',
    },
  },

  MASK: {
    // if you are using any of  “&”, “<“, “>”, ‘”‘, “'” and “‘” in your pattern,
    // please make sure it is a valid json string by escaping these characters.
    Simple: ['Simple', '', 'XXX-XXX-'],
    MaskEmail: ['Regex', '(?<=.).(?=.*@)', '*'],
    CustomRegex: ['Regex', '', '*'],
  },
  PATTERN: {
    // if you are using any of  “&”, “<“, “>”, ‘”‘, “'” and “‘” in your pattern,
    // please make sure it is a valid json string by escaping these characters.
    OnlyLettersNumbersSpaces: ['^[A-Za-z0-9 ]{0,64}$', 'Please only use letters, numbers and spaces.'],
    UserId: [
      '^[a-zA-Z0-9]+[a-zA-Z0-9_-]*$',
      'The username you provided is not valid. It must begin with an alphabet or number and can contain alphabets, numbers and the following symbols: _ -',
    ],
    Password: [
      '^((?=.*[a-z])(?=.*[A-Z])(?=.*d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])|(?=.*[a-z])(?=.*d)(?=.*[^A-Za-z0-9])|(?=.*[A-Z])(?=.*d)(?=.*[^A-Za-z0-9]))([A-Za-zd@#$%^&*-_+=[]{}|\\:\',?/`~"();!]|.(?!@)){8,16}$',
      '8-16 characters, containing 3 out of 4 of the following: Lowercase characters, uppercase characters, digits (0-9), and one or more of the following symbols: @ # $ % ^ & * - _ + = [ ] { } |  : \' , ? / ` ~ " ( ) ; .',
    ],
    Email: ['^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$', 'Please enter a valid email address.'],
    OutlookLiveGmail: [
      '^[a-zA-Z0-9_.+-]+@(outlook[.]com|live[.]com|gmail[.]com)',
      'Please enter a email address from one of the following domains: outlook.com, live.com, gmail.com',
    ],
    Digits: ['^[0-9]{1,15}$', 'Please enter digits'],
    SixDigitCode: ['^[0-9]{6}$', 'Enter the 6-digit code'],
    PhoneNumber: ['^[0-9]+$', 'The phone number should only be numbers'],
    CustomRegex: ['', 'Enter your custom help text'],
  },

  SESSIONCONTEXT: [
    { label: 'LanguageName', value: '{Culture:LanguageName}' },
    { label: 'LCID', value: '{Culture:LCID}' },
    { label: 'RegionName', value: '{Culture:RegionName}' },
    { label: 'RFC5646', value: '{Culture:RFC5646}' },
    { label: 'PolicyId', value: '{Policy:PolicyId}' },
    {
      label: 'RelyingPartyTenantId',
      value: '{Policy:RelyingPartyTenantId}',
    },
    {
      label: 'TenantObjectId',
      value: '{Policy:TenantObjectId}',
    },
    {
      label: 'TrustFrameworkTenantId',
      value: '{Policy:TrustFrameworkTenantId}',
    },
    { label: 'BuildNumber', value: '{Context:BuildNumber}' },
    { label: 'CorrelationId', value: '{Context:CorrelationId}' },
    { label: 'DateTimeInUtc', value: '{Context:DateTimeInUtc}' },
    { label: 'DeploymentMode', value: '{Context:DeploymentMode}' },
    { label: 'HostName', value: '{Context:HostName}' },
    { label: 'IPAddress', value: '{Context:IPAddress}' },
    { label: 'KMSI', value: '{Context:KMSI}' },
    { label: 'CurrentDateTime', value: 'CurrentDateTime' },
    { label: 'OIDC AuthenticationContextReferences', value: '{OIDC:AuthenticationContextReferences}' },
    { label: 'OIDC ClientId', value: '{OIDC:ClientId}' },
    { label: 'OIDC DomainHint', value: '{OIDC:DomainHint}' },
    { label: 'OIDC LoginHint', value: '{OIDC:LoginHint}' },
    { label: 'OIDC MaxAge', value: '{OIDC:MaxAge}' },
    { label: 'OIDC Nonce', value: '{OIDC:Nonce}' },
    { label: 'OIDC Password', value: '{OIDC:Password}' },
    { label: 'OIDC Prompt', value: '{OIDC:Prompt} ' },
    { label: 'OIDC RedirectUri', value: '{OIDC:RedirectUri}' },
    { label: 'OIDC Resource', value: '{OIDC:Resource}' },
    { label: 'OIDC Scope', value: '{OIDC:Scope}' },
    { label: 'OIDC Username', value: '{OIDC:Username}' },
    { label: 'OAUTH Key-Value', value: 'OAUTH-KV:' },
    { label: 'SAML AuthnContextClassReferences', value: '{SAML:AuthnContextClassReferences}' },
    { label: 'SAML NameIdPolicyFormat', value: '{SAML:NameIdPolicyFormat}' },
    { label: 'SAML Issuer', value: '{SAML:Issuer}' },
    { label: 'SAML AllowCreate', value: '{SAML:AllowCreate}' },
    { label: 'SAML ForceAuthn', value: '{SAML:ForceAuthn}' },
    { label: 'SAML ProviderName', value: '{SAML:ProviderName}' },
    { label: 'SAML RelayState', value: '{SAML:RelayState}' },
    { label: 'SAML Subject', value: '{SAML:Subject}' },
    { label: 'SAML Binding', value: '{SAML:Binding}' },
  ],
};
